import QueryRendererContainer from './QueryRendererContainer'

export default QueryRendererContainer
